exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upLoadPicBox[data-v-edd21574]{width:100%}.upLoadPicBox .pictrue[data-v-edd21574]{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:5px}.upLoadPicBox .pictrue img[data-v-edd21574]{width:60px;height:60px}", ""]);

// exports
